import { useState, useEffect, useMemo } from "react";
import { useAuth } from "../../hooks"; // Tu hook de Auth global
import { InstitutionReviApi } from "../../api/revi/institutionApi";

export function useInstitutionProfile() {
  const { user, accessToken } = useAuth();
  const [institution, setInstitution] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Instancia memorizada de la API
  const api = useMemo(() => new InstitutionReviApi(), []);

  useEffect(() => {
    let isMounted = true;

    const fetchProfile = async () => {
      if (!user || !accessToken) return;

      try {
        setLoading(true);

        // 1. Lógica de Resolución de Identidad (Identity Shield)
        // Buscamos el ID en user.institutions (array) o user.institution (objeto/string)
        // El modelo User.js dice: institutions: [{ ref: 'InstitutionEducaschool' }]
        // pero en el contexto Revi a veces viene directo.
        const userData = user.user || user;

        // Estrategia defensiva para encontrar el ID
        let institutionId = null;

        if (userData.institutions && userData.institutions.length > 0) {
          institutionId = userData.institutions[0]; // Tomamos la primera por defecto
        } else if (
          userData.role === "revi" ||
          userData.role === "institution"
        ) {
          // Fallback: A veces el ID del usuario ES el vínculo si es admin de inst.
          // O puede venir en una propiedad custom.
          // Si user.js tiene institutions poblado, usamos el _id de ese objeto
          if (typeof userData.institutions?.[0] === "object") {
            institutionId = userData.institutions[0]._id;
          }
        }

        if (!institutionId) {
          // Último intento: Si no hay array, quizás el endpoint /user/me no populó
          // y necesitamos confiar en que el usuario sepa su ID (raro) o lanzar error.
          // Para este refactor, asumimos que institutions[0] existe (string o objeto).
          console.warn(
            "No se detectó ID de institución en el usuario:",
            userData,
          );
          throw new Error("No tienes una institución asignada a tu cuenta.");
        }

        // Asegurarnos de que es un String, no un objeto poblado
        const idString =
          typeof institutionId === "object" ? institutionId._id : institutionId;

        // 2. Llamada a API
        const data = await api.getProfile(accessToken, idString);

        if (isMounted) setInstitution(data);
      } catch (err) {
        if (isMounted) setError(err.message);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchProfile();

    return () => {
      isMounted = false;
    };
  }, [user, accessToken, api]);

  return { institution, loading, error };
}
